const getDefaultState = () => {
  return {
    loading: false,
    filter: {
      email: "",
      groups: "",
    },

    users: [],
    partners: [],
    recipients: [],
    plants: [],
    splits: [],
    banks: [],
    plans: [],
    utilityCompanies: [],
    cooperatives: [],
    holidays: [],
    tabulations: [],
    urlShortners: [],
    contracts: [],

    user: null,
    plan: null,
    urlShortner: null,

    partnerDialog: false,
    recipientDialog: false,
    powerPlantDialog: false,
    splitDialog: false,
    powerPlantContractsList: false,
    documents: [],
  };
};

// initial state
const state = getDefaultState();

export default {
  getDefaultState,
  ...state,
};
